//@ts-nocheck
//@ts-nocheck
import { Box, Flex, Link, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import Icon from "./ui-elements/Icon";
import { distanceInWordsStrict as timeAgo } from "date-fns";
import { observer } from "mobx-react-lite";
import Pluralize from "pluralize";
import * as React from "react";
import { IServerRequestInfo } from "../stores";
import { capFirstLetter, getLessonTime } from "../utils/functions";

type Props = {
  students: any;
  handleShow: () => void;
  show: boolean;
  requestStatus?: any;
  lostRequest: any;
  store: IServerRequestInfo;
  lessonInfo: any;
};

const TutorResponseSummary = observer(
  ({
    students,
    handleShow = () => {},
    show,
    requestStatus,
    lostRequest,
    store,
    lessonInfo,
    ...rest
  }: Props) => {
    const hasAccepted = store.hasAccepted;
    const noResponse = store.noResponse;
    const declined = store.declined;
    const tutorResponse = store.tutorResponse;

    const timeOfLesson = getLessonTime({
      lessonTime: lessonInfo.lessonTime,
      lessonHours: lessonInfo.lessonHours,
    });

    const lessonIcon = lessonInfo.lessonType === "physical" ? "pin" : "online";
    const lessons = lessonInfo.lessonDays.length * lessonInfo.lessonDuration;
    const duration =
      lessonInfo.lessonDuration === 4
        ? "per month"
        : `in ${Pluralize("week", lessonInfo.lessonDuration, true)}`;

    const statusMessage = () => {
      if (hasAccepted) return "You accepted request";
      if (noResponse) return "You didn't respond";
      if (declined) return "You declined request";
    };

    return (
      <Box
        mx={[5, 6]}
        p={[5, 5]}
        bg={show ? "white" : "neutral.100"}
        borderWidth="2xs"
        rounded="fbRadius"
        onClick={() => hasAccepted && !lostRequest && handleShow()}
        _hover={{
          borderColor: hasAccepted && !lostRequest ? "gray.300" : "inherit",
          cursor: hasAccepted && !lostRequest ? "pointer" : "auto",
        }}
        {...rest}
      >
        <Flex direction={["column", "row"]}>
          <Flex mb={[5, 0]} justifyContent="space-between">
            <Icon
              name={hasAccepted ? "checkmark" : "close-circle"}
              color={hasAccepted ? "green.500" : "red.500"}
              size={8}
              mr={[0, 5]}
            />

            {hasAccepted && !lostRequest && (
              <Stack
                isInline
                align="center"
                color="blue.500"
                display={["block", "none"]}
              >
                <Link fontSize="sm">
                  {show ? "Hide details" : "View details"}
                </Link>
                <Icon name={show ? "chevron-up" : "chevron-down"} />
              </Stack>
            )}
          </Flex>
          <Stack flex={1}>
            <Flex justifyContent="space-between">
              <Box>
                <Text fontWeight="bold" lineHeight="none">
                  {statusMessage()}
                </Text>
                <Text mt={1} opacity={0.7} fontSize="sm">
                  {timeAgo(new Date(tutorResponse.submittedDate), new Date())}{" "}
                  ago
                </Text>
              </Box>

              {hasAccepted && !lostRequest && (
                <Stack
                  isInline
                  align="center"
                  color="blue.500"
                  display={["none", "block"]}
                >
                  <Link fontSize="sm">
                    {show ? "Hide details" : "View details"}
                  </Link>
                  <Icon name={show ? "chevron-up" : "chevron-down"} />
                </Stack>
              )}
            </Flex>

            <SimpleGrid columns={[1, 2]} mt={2} spacing={2}>
              <Stack isInline align="center">
                <Icon name="group" />
                <Text>{Pluralize("student", students.length, true)}</Text>
              </Stack>
              <Stack isInline align="center">
                <Icon name="calendar-outline" />
                <Text>
                  {Pluralize("lesson", lessons, true)} {duration}
                </Text>
              </Stack>
              <Stack isInline align="center">
                <Icon name="time" />
                <Text>From {timeOfLesson}</Text>
              </Stack>
              <Stack isInline align="center">
                <Icon name={lessonIcon} />
                <Text>{capFirstLetter(lessonInfo.lessonType)} classes</Text>
              </Stack>
            </SimpleGrid>
          </Stack>
        </Flex>
      </Box>
    );
  },
);

export default TutorResponseSummary;
